import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=9362c2c0&scoped=true"
import script from "./order-item.vue?vue&type=script&lang=js"
export * from "./order-item.vue?vue&type=script&lang=js"
import style0 from "./order-item.vue?vue&type=style&index=0&id=9362c2c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9362c2c0",
  null
  
)

export default component.exports